const config = {
	HOME_WIDGET_ITEMS_MAX_SLOTS: 6,
	HOME_PAGE_DY_WIDGET_ITEMS_MAX_SLOTS: 6
};

export default config;
